
import { Component, Prop, Vue } from "vue-property-decorator";
import { Query, ShiftOrderRecordDTO, StockShiftOrderServiceProxy } from '@/service-proxies/app-v2/wms.service-proxies'
import dayjs from 'dayjs';
const ssosp = new StockShiftOrderServiceProxy()

@Component({
  components: {
  }
})
export default class InventoryStatistics extends Vue {
  get columns() {
    return [
      {
        title: this.$t('page_material_warehousing_code'),
        dataIndex: 'inOrderCode',
        ellipsis: true,
        key: 'inOrderCode',
        width: 150,
      },
      {
        title: this.$t('page_material_ware_out_code'),
        dataIndex: 'outOrderCode',
        ellipsis: true,
        key: 'outOrderCode',
        width: 150,
      },
      {
        title: this.$t('page_material_warehousing_name'),
        dataIndex: 'inOrderName',
        ellipsis: true,
        key: 'inOrderName',
        width: 150,
      },
      {
        title: this.$t('page_material_warehousing_receipt_type'),
        dataIndex: 'stockInType',
        ellipsis: true,
        key: 'stockInType',
        width: 150,
      },
      {
        title: this.$t('page_material_warehousing_to_stockInTime'),
        dataIndex: 'stockInTime',
        ellipsis: true,
        key: 'stockInTime',
        width: 150,
        customRender: (value, _record, index) => {
          return (
            <span>
              { dayjs(value).format('YYYY-MM-DD HH:mm:ss') }
            </span>
          )
        },
      },
      {
        title: this.$t('page_material_warehousing_material_batch'),
        dataIndex: 'batchCode',
        ellipsis: true,
        key: 'batchCode',
        width: 150,
      },
      {
        title: this.$t('page_material_ware_out_planCode'),
        dataIndex: 'planCode',
        ellipsis: true,
        key: 'planCode',
        width: 150,
      },
      {
        title: this.$t('page_material_warehousing_to_stockInNum'),
        dataIndex: 'stockInNum',
        ellipsis: true,
        key: 'stockInNum',
        width: 150,
      },
      {
        title: this.$t('page_material_warehousing_to_receivingUser'),
        dataIndex: 'receivingUser',
        ellipsis: true,
        key: 'receivingUser',
        width: 150,
        customRender: (value, _record, index) => {
          return (
            <span>
              { this.findUser(value) }
            </span>
          )
        },
      },
      {
        title: this.$t('page_material_warehousing_to_deliveryUser'),
        dataIndex: 'deliveryUser',
        ellipsis: true,
        key: 'deliveryUser',
        width: 150,
        customRender: (value, _record, index) => {
          return (
            <span>
              { this.findUser(value) }
            </span>
          )
        },
      }
    ]
  };
  
  @Prop({ default: () => [] }) readonly data: Array<string>;
  @Prop({ default: () => {} }) readonly pagination: any;
  @Prop({ default: 0 }) readonly total: Number;
  @Prop({ default: 300 }) readonly height: Number;
  @Prop({ default: false }) readonly loading: Boolean;
  @Prop({ default: () => [] }) readonly employeesList: any;
  
  showTotal(total){
    return (this.$t('Total…items') as string).replace('{0}', total)
  }


  handleTableChange(current: number, pageSize: number) {
    this.$emit('handleTableChange',current,pageSize)
  }

  findUser(value){
    const user = this.employeesList.find(res => res.id === value)
    console.log(this.employeesList,value)
    return user ? user.name : ""
  }

  render() {
    return (
      <div style="height: 100%;position: relative;">
        <ml-table
          pagination={false}
          columns={this.columns}
          loading={this.loading}
          dataSource={this.data}
          bordered
          scroll={{ y: this.height, x: 2350 }}
        >
        </ml-table>
        <a-pagination
          style="position:absolute;bottom: 4px;right: 20px"
          show-total={total => `${ this.showTotal(total) }`}
          current={this.pagination.current}
          total={this.total}
          pageSize={this.pagination.size}
          on-change={this.handleTableChange}
          on-showSizeChange={this.handleTableChange}
        />
      </div>
    )
  }
}